import React, { useState } from 'react';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../../ui/select';
import { Input } from '../../ui/input';

const OTHER = '__other__';
// HR-RECRUIT-ROLE-001: job function (descriptive) — never an RBAC grant. Mirrors backend normalize_job_role.
export const normalizeRole = (v) => String(v || '').trim().toLowerCase().replace(/[^a-z0-9]+/g, '_').replace(/^_+|_+$/g, '');
export const roleLabel = (v) => String(v || '').replace(/_/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase());

export const RoleSelect = ({ value, onChange, options, error, testId = 'role-select' }) => {
  const known = options.some((r) => r.value === value);
  const [otherPicked, setOtherPicked] = useState(false);
  const [text, setText] = useState('');
  const custom = otherPicked || (!!value && !known);
  const shown = text || (custom && !otherPicked ? roleLabel(value) : '');

  const pick = (v) => {
    if (v === OTHER) { setOtherPicked(true); setText(''); onChange(''); return; }
    setOtherPicked(false); setText(''); onChange(v);
  };
  return (
    <div className="space-y-1.5">
      <Select value={custom ? OTHER : (value || '')} onValueChange={pick}>
        <SelectTrigger className={error ? 'border-red-500' : ''} data-testid={`${testId}-trigger`}><SelectValue placeholder="Select role" /></SelectTrigger>
        <SelectContent className="max-h-72">
          {options.map((r) => <SelectItem key={r.value} value={r.value} data-testid={`${testId}-opt-${r.value}`}>{r.label}</SelectItem>)}
          <SelectItem value={OTHER} className="font-semibold text-blue-700 border-t mt-1 pt-2" data-testid={`${testId}-opt-other`}>Other — type a role…</SelectItem>
        </SelectContent>
      </Select>
      {custom && (
        <Input autoFocus={otherPicked} value={shown} placeholder="e.g. Desktop Support Engineer" maxLength={100}
          onChange={(e) => { setOtherPicked(true); setText(e.target.value); onChange(normalizeRole(e.target.value)); }}
          className={error ? 'border-red-500' : ''} data-testid={`${testId}-custom-input`} />
      )}
      {custom && <p className="text-[11px] text-slate-500" data-testid={`${testId}-custom-hint`}>Job function only — does not grant any application access.</p>}
    </div>
  );
};
